import { render, staticRenderFns } from "./CallDrawer.vue?vue&type=template&id=0c3b595c"
import script from "./CallDrawer.vue?vue&type=script&lang=js"
export * from "./CallDrawer.vue?vue&type=script&lang=js"
import style0 from "./CallDrawer.vue?vue&type=style&index=0&id=0c3b595c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/panzhijing/蛋卷科技/danjuan-admin/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3b595c')) {
      api.createRecord('0c3b595c', component.options)
    } else {
      api.reload('0c3b595c', component.options)
    }
    module.hot.accept("./CallDrawer.vue?vue&type=template&id=0c3b595c", function () {
      api.rerender('0c3b595c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CallDrawer.vue"
export default component.exports